import { Label } from "../../../components/ui/label";
import { Combobox } from "../../../components/ui/combobox";
import type { Client, Professional } from "../../../types";

interface ClientProfessionalSectionProps {
  t: any;
  lang: string;
  clients: Client[];
  professionals: Professional[];
  specialties: any[];
  insuranceOptions: any[];
  clientId: number | null;
  setClientId: (id: number | null) => void;
  employeeId: number | null;
  setEmployeeId: (id: number | null) => void;
  specialtyId: number | null;
  setSpecialtyId: (id: number | null) => void;
  insuranceProviderId: number | null;
  setInsuranceProviderId: (id: number | null) => void;
  setRoomId: (id: number | null) => void;
}

export function ClientProfessionalSection({
  t,
  lang,
  clients,
  professionals,
  specialties,
  insuranceOptions,
  clientId,
  setClientId,
  employeeId,
  setEmployeeId,
  specialtyId,
  setSpecialtyId,
  insuranceProviderId,
  setInsuranceProviderId,
  setRoomId,
}: ClientProfessionalSectionProps) {
  return (
    <section className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label>{t.editModal.client}</Label>
          <Combobox
            options={clients.map((c) => ({ value: String(c.id), label: c.name }))}
            value={clientId ? String(clientId) : undefined}
            onChange={(v) => setClientId(Number(v))}
            placeholder={t.editModal.select}
            searchPlaceholder={t.newPage.comboboxSearch}
            emptyMessage={t.newPage.comboboxEmpty}
          />
        </div>

        <div className="space-y-2">
          <Label>{t.editModal.professional}</Label>
          <Combobox
            options={professionals.map((p) => ({ value: String(p.id), label: p.name }))}
            value={employeeId ? String(employeeId) : undefined}
            onChange={(v) => setEmployeeId(Number(v))}
            placeholder={t.editModal.select}
            searchPlaceholder={t.newPage.comboboxSearch}
            emptyMessage={t.newPage.comboboxEmpty}
            className="w-full"
          />
        </div>

        {specialties.length > 0 && (
          <div className="space-y-2">
            <Label>
              {t.editModal.specialty} <span className="text-red-500">*</span>
            </Label>
            <Combobox
              options={specialties.map((s) => ({ value: String(s.id), label: s.name }))}
              value={specialtyId ? String(specialtyId) : undefined}
              onChange={(v) => {
                const id = Number(v);
                setSpecialtyId(id);
                if (id) {
                  const spec = specialties.find((s) => s.id === id);
                  if (spec?.room_id) setRoomId(spec.room_id);
                }
              }}
              placeholder={t.editModal.select}
              searchPlaceholder={t.newPage.comboboxSearch}
              emptyMessage={t.newPage.comboboxEmpty}
              className="w-full"
            />
          </div>
        )}

        <div className="space-y-2">
          <Label>{lang === "pt" ? "Convênio" : "Insurance"}</Label>
          <Combobox
            options={insuranceOptions}
            value={insuranceProviderId ? String(insuranceProviderId) : undefined}
            onChange={(v) => setInsuranceProviderId(Number(v))}
            placeholder={t.editModal.select}
            searchPlaceholder={t.newPage.comboboxSearch}
            emptyMessage={t.newPage.comboboxEmpty}
          />
        </div>
      </div>
    </section>
  );
}
